// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___35xsB","addText":"AddFilterBox__addText___1hhPx","addFilterContainer":"AddFilterBox__addFilterContainer___158fb","addIcon":"AddFilterBox__addIcon___HU0uy"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/projects/components/AddFilterBox.scss
// module id = 1729
// module chunks = 0